import 'gsap';
import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';

let $body;
let $lightboxWrap;
let $imageContainer;
let flckty = null;
let isOpen = false;

const init = () => {
    $body = $('body');
    $lightboxWrap = $body.find('[data-lightbox]');
    $imageContainer = $body.find('[data-lightbox-image-container]');

    $body.on('click', '[data-lightbox-trigger]', e => {
        if (Viewport.breakpoint.size >= 750) {
            openSlideshow($(e.triggerTarget));
        }
    });
    
    $lightboxWrap.on('click', '[data-lightbox-close-button]', e => {
        close();
    });

    $lightboxWrap.on('click', '[data-lightbox-nav-button]', e => {
        const $el = $(e.triggerTarget);
        navigate($el.hasClass('-prev') ? 'prev' : 'next');
    });

    Viewport.on('resize', onResize);
};

const onResize = () => {

};

const onKeyup = e => {
    const key = e.keyCode || e.which;
    if (key === 27) {
        close();
    }
};

const openSlideshow = $triggerElement => {
    const $slideshowImages = $body.find('[data-lightbox-image]');
    const selectedImage = $triggerElement.data('lightbox-image');
    const selectedIndex = getIndexOfSelectedImage($slideshowImages, selectedImage);

    $imageContainer.empty();
    
    $slideshowImages.each((el, i) => {
        const $el = $(el);
        
        if ($el.data('lightbox-image') !== '') {
            const $img = $('<div class="lightbox-slideshow__slide pos-r w-100 h-100" data-lightbox-slide><div class="lightbox-slideshow__slide-inner pos-r w-100 h-100" style="background-image: url(' + $el.data('lightbox-image') + ')"></div></div>')
            $imageContainer.append($img);
        }
    });

    $lightboxWrap.css({ display: 'block', opacity: 0 });
    $imageContainer.css({ opacity: 0 });
    document.addEventListener('keyup', onKeyup);

    initFlickity(selectedIndex);
    
    TweenLite.to($lightboxWrap.nodes, 0.4, { opacity: 1 });
    TweenLite.to($imageContainer.nodes, 0.5, { delay: 0.2, opacity: 1 });
    
    isOpen = true;
};

const close = () => {
    $lightboxWrap.css({ display: 'none' });
    document.removeEventListener('keyup', onKeyup);
    destroyFlickity();
};

const getIndexOfSelectedImage = ($slideshowImages, selectedImage) => {
    let r = 0;

    $slideshowImages.each((el, i) => {
        if ($(el).data('lightbox-image') === selectedImage) {
            r = i;
        }
    });

    return r;
};

const initFlickity = selectedIndex => {
    if (flckty !== null) {
        destroyFlickity();
    }
    
    flckty = new Flickity($imageContainer.get(0), {
        cellSelector: '[data-lightbox-slide]',
        wrapAround: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: true,
        dragThreshold: 10,
        cellAlign: 'center',
        setGallerySize: true,
        percentPosition: true,
        accessibility: false,
        initialIndex: selectedIndex
    });

    flckty.resize();
};

const destroyFlickity = () => {
    if (flckty !== null) {
        flckty.destroy();
        flckty = null;
    }
};

const navigate = direction => {
    if (flckty !== null) {
        if (direction === 'prev') {
            flckty.previous();
        } else {
            flckty.next();
        }
    }
};


// Public api for module
export default {
    init
};



// WEBPACK FOOTER //
// ./src/js/modules/LightboxSlideshow.js